import React from 'react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from '../hooks/useIsMobile';
import { Button, Icon, Logo } from '../ui';
import { IconName } from '../ui/iconSprite';
import ThemeToggle from '../ui/ThemeToggle';

/** /welcome — Home. QR СӨХ thesis: хаалганд наасан QR → утас → төлбөр. (handoff §3) */
export default function LandingPage() {
  const navigate = useNavigate();
  const m = useIsMobile(768);
  const secPad = m ? '36px 20px' : '56px 40px';

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--ink)' }}>
      {/* Топбар */}
      <header style={{ background: 'var(--card)', borderBottom: '1px solid var(--line)', padding: m ? '12px 16px' : '14px 20px' }}>
        <div style={{ maxWidth: 1180, margin: '0 auto', display: 'flex', alignItems: 'center', gap: 10 }}>
          <Logo size={32} /><span style={{ fontWeight: 700, fontSize: 16 }}>Сайн Хөрш</span>
          <span style={{ flex: 1 }} />
          <ThemeToggle size={40} />
          <Button variant="secondary" size="sm" style={{ minHeight: 40 }} onClick={() => navigate('/login')}>Нэвтрэх</Button>
          {!m && <Button size="sm" style={{ minHeight: 40 }} onClick={() => navigate('/register')}>СӨХ бүртгүүлэх</Button>}
        </div>
      </header>

      {/* Hero */}
      <section style={{ maxWidth: 1180, margin: '0 auto', padding: m ? '32px 20px' : '64px 56px', display: 'grid', gridTemplateColumns: m ? '1fr' : '1.1fr 1fr', gap: 32, alignItems: 'center' }}>
        <div>
          <span className="sh-chip sh-chip--paid" style={{ marginBottom: 16 }}><Icon name="qr" size={14} />Апп, бүртгэл, нууц үг хэрэггүй</span>
          <h1 style={{ fontSize: m ? 34 : 48, fontWeight: 700, lineHeight: 1.1, letterSpacing: '-.02em', margin: '0 0 16px' }}>Айл бүрд нэг QR.<br />Уншуулаад л төлнө.</h1>
          <p style={{ fontSize: 17, color: 'var(--muted)', maxWidth: 480, margin: '0 0 24px', lineHeight: 1.5 }}>
            СӨХ хаалганд QR карт наана. Оршин суугч утсаараа уншуулж үлдэгдлээ хараад QPay-ээр төлж, санал хүсэлтээ илгээнэ.
          </p>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <Button style={{ minHeight: 48 }} block={m} onClick={() => navigate('/register')}>СӨХ-өө үнэгүй бүртгүүлэх</Button>
            <Button variant="secondary" style={{ minHeight: 48 }} block={m} icon="phone" onClick={() => navigate('/u/demo')}>Оршин суугчийн жишээ харах</Button>
          </div>
          <button onClick={() => navigate('/how')} className="sh-btn sh-btn--ghost" style={{ marginTop: 10, minHeight: 40, padding: '0 8px', color: 'var(--green)', fontWeight: 600 }}><Icon name="eye" size={18} />QR хэрхэн ажилладаг вэ? — хөдөлгөөнт дүрслэл</button>
        </div>
        <HeroIllustration compact={m} />
      </section>

      {/* QR хэрхэн ашиглах */}
      <section style={{ background: 'var(--card)', borderTop: '1px solid var(--line)', borderBottom: '1px solid var(--line)', padding: secPad }}>
        <div style={{ maxWidth: 1180, margin: '0 auto' }}>
          <h2 style={{ fontSize: 24, fontWeight: 700, textAlign: 'center', margin: '0 0 6px' }}>QR-ийг хэрхэн ашиглах вэ?</h2>
          <p style={{ textAlign: 'center', color: 'var(--muted)', margin: '0 0 28px', fontSize: 14 }}>
            <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: 3, background: 'var(--green)', verticalAlign: 'middle', marginRight: 6 }} />СӨХ хийнэ ·
            <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: 3, background: 'var(--gold)', verticalAlign: 'middle', margin: '0 6px 0 10px' }} />оршин суугч хийнэ
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: m ? '1fr' : 'repeat(4, 1fr)', gap: 14 }}>
            {STEPS.map((s, i) => (
              <div key={i} style={{ background: 'var(--bg)', border: '1px solid var(--line)', borderRadius: 12, padding: 18, display: 'flex', flexDirection: m ? 'row' : 'column', alignItems: m ? 'flex-start' : 'center', textAlign: m ? 'left' : 'center', gap: 12 }}>
                <span style={{ width: 52, height: 52, borderRadius: '50%', flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  background: s.who === 'soh' ? 'var(--green)' : 'var(--gold)', color: s.who === 'soh' ? '#fff' : '#1c2b22' }}><Icon name={s.icon} size={24} /></span>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.06em', color: s.who === 'soh' ? 'var(--green)' : 'var(--amber)', marginBottom: 4 }}>{s.who === 'soh' ? 'СӨХ' : 'ОРШИН СУУГЧ'}</div>
                  <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>{i + 1}. {s.title}</div>
                  <div style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.45 }}>{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 22 }}>
            <Button variant="secondary" style={{ minHeight: 44 }} icon="eye" onClick={() => navigate('/how')}>Оршин суугчийн алхмуудыг хөдөлгөөнтөөр харах</Button>
          </div>
        </div>
      </section>

      {/* СӨХ-ийн 3 алхам */}
      <section style={{ maxWidth: 1180, margin: '0 auto', padding: secPad }}>
        <h2 style={{ fontSize: 24, fontWeight: 700, textAlign: 'center', margin: '0 0 28px' }}>СӨХ-ийн 3 алхам</h2>
        <div style={{ display: 'grid', gridTemplateColumns: m ? '1fr' : 'repeat(3, 1fr)', gap: 14 }}>
          {THREE.map((s, i) => (
            <div key={i} className="sh-card">
              <div className="tnum" style={{ fontSize: 36, fontWeight: 700, color: 'var(--green)', lineHeight: 1 }}>0{i + 1}</div>
              <div style={{ fontSize: 17, fontWeight: 700, margin: '10px 0 6px' }}>{s.title}</div>
              <div style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.5 }}>{s.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Боломжууд */}
      <section style={{ background: 'var(--card)', borderTop: '1px solid var(--line)', padding: secPad }}>
        <div style={{ maxWidth: 1180, margin: '0 auto' }}>
          <h2 style={{ fontSize: 24, fontWeight: 700, textAlign: 'center', margin: '0 0 28px' }}>Боломжууд</h2>
          <div style={{ display: 'grid', gridTemplateColumns: m ? '1fr' : 'repeat(3, 1fr)', gap: 14 }}>
            {FEATURES.map((f, i) => (
              <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', padding: 14, background: 'var(--bg)', border: '1px solid var(--line)', borderRadius: 12 }}>
                <Icon name={f.icon} size={22} style={{ color: 'var(--green)', marginTop: 2 }} />
                <div><div style={{ fontWeight: 600, marginBottom: 2 }}>{f.title}</div><div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.45 }}>{f.desc}</div></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <footer style={{ padding: '24px 20px', textAlign: 'center', fontSize: 12, color: 'var(--muted)', lineHeight: 1.8 }}><div>© 2026 Сайн Хөрш · Улаанбаатар · nationalmobile976@gmail.com</div><div>Харилцах утас: <a href="tel:96900520" style={{ color: 'inherit', fontWeight: 600, textDecoration: 'none' }}>96900520</a></div></footer>
    </div>
  );
}

const STEPS: { who: 'soh' | 'res'; icon: IconName; title: string; desc: string }[] = [
  { who: 'soh', icon: 'printer', title: 'Хэвлэх', desc: 'Айл бүрийн QR картыг A4/A6-д хэвлэж хаалганд наана.' },
  { who: 'res', icon: 'scan', title: 'Уншуулах', desc: 'Утасны камераар уншуулна. Апп, бүртгэл хэрэггүй.' },
  { who: 'res', icon: 'wallet', title: 'Төлөх', desc: 'Үлдэгдлээ хараад QPay-ээр 30 секундэд төлнө.' },
  { who: 'res', icon: 'message', title: 'Санал хүсэлт', desc: 'Гомдол, саналаа тоотоо бичэлгүй шууд илгээнэ.' },
];
const THREE = [
  { title: 'Бүртгүүлэх', desc: 'СӨХ-ийн нэр, имэйл, утас — 2 минут. Нууц үг байхгүй, кодоор нэвтэрнэ.' },
  { title: 'Айлуудаа оруулах', desc: 'Excel-ээс чирж импортлох эсвэл нэг бүрчлэн бүртгэх. Айл бүрд QR автоматаар үүснэ.' },
  { title: 'QR хэвлэж наах', desc: 'Байраар шүүж бүх QR-ийг нэг PDF болгож хэвлэнэ. Дараа нь төлбөр өөрөө орж ирнэ.' },
];
const FEATURES: { icon: IconName; title: string; desc: string }[] = [
  { icon: 'wallet', title: 'QPay төлбөр', desc: 'Бүх банкны апп. Төлбөр автоматаар бүртгэгдэнэ.' },
  { icon: 'receipt', title: 'Нэхэмжлэх, өрийн хяналт', desc: 'Сар бүрийн хураамж, нэмэлт хуваарилалт, өртэй айлын жагсаалт.' },
  { icon: 'message', title: 'Санал хүсэлт inbox', desc: 'Тоотоор нь ирнэ. Шинэ → Хийгдэж → Шийдэгдсэн.' },
  { icon: 'megaphone', title: 'Мэдэгдэл', desc: 'Усны завсарлага, хурлын зар — SMS, имэйлээр.' },
  { icon: 'car', title: 'Автозогсоол', desc: 'Торон схем: сул, эзэлсэн, засварт.' },
  { icon: 'chart', title: 'Тайлан', desc: 'Орлого-зарлага, нягтлан бодохын экспорт.' },
];

/** Hero зураглал (CSS): хаалга + QR карт → утас (үлдэгдэл, CTA) → амжилт. data-illustration="hero" — дараа зургаар солиход тусгаарласан. */
function HeroIllustration({ compact }: { compact: boolean }) {
  const sc = compact ? .72 : 1;
  return (
    <div data-illustration="hero" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14 * sc, transform: compact ? 'scale(.9)' : undefined, transformOrigin: 'center', overflow: 'visible', padding: compact ? '8px 0 0' : 0 }}>
      {/* Хаалга */}
      <div style={{ width: 150 * sc, height: 260 * sc, background: '#7a5a3a', border: `${6 * sc}px solid #5a3f27`, borderRadius: 6, position: 'relative', boxShadow: 'var(--shadow)', flexShrink: 0 }}>
        <div style={{ position: 'absolute', right: 10 * sc, top: '50%', width: 10 * sc, height: 10 * sc, borderRadius: '50%', background: 'var(--gold)' }} />
        <div style={{ position: 'absolute', left: '50%', top: 34 * sc, transform: 'translateX(-50%) rotate(-2deg)', width: 92 * sc, background: '#fbfaf6', color: '#1c2b22', borderRadius: 8, padding: 8 * sc, boxShadow: '0 6px 16px rgba(0,0,0,.25)', textAlign: 'center' }}>
          <div style={{ fontSize: 8 * sc, color: '#236844', fontWeight: 700, whiteSpace: 'nowrap' }}>Нарны Хороолол СӨХ</div>
          <QrMock size={64 * sc} />
          <div style={{ fontSize: 11 * sc, fontWeight: 800 }}>А-101</div>
        </div>
      </div>
      <Icon name="arrow-right" size={28 * sc} style={{ color: 'var(--green)', flexShrink: 0 }} />
      {/* Утас */}
      <div style={{ width: 120 * sc, height: 236 * sc, background: '#1c2b22', borderRadius: 22 * sc, padding: 8 * sc, flexShrink: 0, boxShadow: 'var(--shadow)' }}>
        <div style={{ background: '#f4f1e8', color: '#1c2b22', borderRadius: 16 * sc, height: '100%', padding: 10 * sc, display: 'flex', flexDirection: 'column', gap: 6 * sc }}>
          <div style={{ fontSize: 7 * sc, color: '#5c6a61' }}>А байр, 101 тоот</div>
          <div style={{ background: '#fff', borderRadius: 8, padding: 8 * sc, textAlign: 'center' }}>
            <div style={{ fontSize: 7 * sc, color: '#5c6a61' }}>Үлдэгдэл</div>
            <div style={{ fontSize: 13 * sc, fontWeight: 800, color: '#b3261e', whiteSpace: 'nowrap' }}>186 500 ₮</div>
          </div>
          <div style={{ background: 'linear-gradient(135deg,#2f7d52,#236844)', color: '#fff', borderRadius: 6, padding: `${6 * sc}px 0`, fontSize: 7 * sc, fontWeight: 700, textAlign: 'center' }}>QPay-ээр төлөх</div>
        </div>
      </div>
      <Icon name="arrow-right" size={28 * sc} style={{ color: 'var(--green)', flexShrink: 0 }} />
      <div style={{ width: 96 * sc, height: 96 * sc, borderRadius: '50%', background: 'var(--gold)', color: '#1c2b22', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="check" size={48 * sc} /></div>
    </div>
  );
}
function QrMock({ size }: { size: number }) {
  const cells: number[] = []; let seed = 11;
  for (let i = 0; i < 121; i++) { seed = (seed * 9301 + 49297) % 233280; cells.push(seed / 233280 > .5 ? 1 : 0); }
  const finder = (r: number, c: number) => (r < 3 && c < 3) || (r < 3 && c > 7) || (r > 7 && c < 3);
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(11,1fr)', gap: 1, width: size, height: size, margin: '4px auto', background: '#fff', padding: 3 }}>
      {cells.map((on, i) => { const r = Math.floor(i / 11), c = i % 11; const d = finder(r, c) ? !(r % 3 === 1 && c % 3 === 1) : on === 1; return <div key={i} style={{ background: d ? '#1c2b22' : 'transparent' }} />; })}
    </div>
  );
}
